import { LOGOUT_RTK } from "@/components/access/ducks/Actions"

export default function wrapError(error, fnName) {
  if (!error) {
    console.log(`${fnName} called without error handling`)
  }
  const errorHandler =
    error ||
    ((xmlHttpRequest) => {
      if (xmlHttpRequest.readyState === 0 || xmlHttpRequest.status === 0) {
        return // It's not really an error
      }
      console.log(`${fnName}: ${xmlHttpRequest.responseText}`)
    })

  return (resp) => {
    if (resp.status === 400 && resp.responseJSON?.type === "logout") {
      window.store.dispatch(LOGOUT_RTK())
    }
    errorHandler(resp)
  }
}
